<div *ngIf="config" class="contents">
  <!-- Maximum public users -->
  <mat-form-field class="field max-users" [floatLabel]="'always'">
    <mat-label>Max users</mat-label>
    <input required matInput autocomplete="off" [(ngModel)]="config.apiConfig!.userRestrictions!.maxPublicUsers"
      appNumberValidator [minValue]="0" [maxValue]="10000000" />
  </mat-form-field>
  <button mat-icon-button (click)="updateConfig()" [disabled]="!configChanged"><mat-icon>save</mat-icon></button>
</div>
